// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SectionDivider_wrapper__AmJLZ","text":"SectionDivider_text__S1RWG","line":"SectionDivider_line__6BJ5o"};